import type { UseEmojiPickerType } from '@platejs/emoji/react';
import styles from "./emoji.module.scss";

export type EmojiPickerPreviewProps = Pick<
    UseEmojiPickerType,
    'emoji' | 'hasFound' | 'i18n' | 'isSearching'
>;

export type EmojiPreviewProps = Pick<UseEmojiPickerType, 'emoji'>;

export type NoEmojiPreviewProps = Pick<UseEmojiPickerType, 'i18n'>;

export type PickAnEmojiPreviewProps = NoEmojiPreviewProps;

function EmojiPreview({ emoji }: EmojiPreviewProps) {
    return (
        <>
            <span>
                {emoji?.skins[0].native}
            </span>
            <div>
                <div>{emoji?.name}</div>
                <div>{`:${emoji?.id}:`}</div>
            </div>
        </>
    );
}

function NoEmoji({ i18n }: NoEmojiPreviewProps) {
    return (
        <>
            <span>😢</span>
            <div>
                <div>
                    {i18n.searchNoResultsTitle}
                </div>
                <div>{i18n.searchNoResultsSubtitle}</div>
            </div>
        </>
    );
}

function PickAnEmoji({ i18n }: PickAnEmojiPreviewProps) {
    return (
        <>
            <span>☝️</span>
            <div>
                <div>{i18n.pick}</div>
            </div>
        </>
    );
}

export function EmojiPickerPreview({
                                       emoji,
                                       hasFound = true,
                                       i18n,
                                       isSearching = false,
                                       ...props
                                   }: EmojiPickerPreviewProps) {
    const showPickEmoji = !emoji && (!isSearching || hasFound);
    const showNoEmoji = isSearching && !hasFound;
    const showPreview = emoji && !showNoEmoji && !showNoEmoji;

    return (
        <div className={styles.emojiPreview}>
            {showPreview && <EmojiPreview emoji={emoji} {...props} />}
            {showPickEmoji && <PickAnEmoji i18n={i18n} {...props} />}
            {showNoEmoji && <NoEmoji i18n={i18n} {...props} />}
        </div>
    );
}
